import { render, staticRenderFns } from "./recyclerList.vue?vue&type=template&id=6341f8e8&scoped=true&"
import script from "./recyclerList.vue?vue&type=script&lang=js&"
export * from "./recyclerList.vue?vue&type=script&lang=js&"
import style0 from "./recyclerList.vue?vue&type=style&index=0&id=6341f8e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6341f8e8",
  null
  
)

export default component.exports